import { createMaterialBottomTabNavigator } from "@react-navigation/material-bottom-tabs";
import { Feather } from "@expo/vector-icons";
import { useSelector } from "react-redux";
import CameraScreen from "../../screens/camera";
import ProfileScreen from "../../screens/profile";
import SearchScreen from "../../screens/search";
import FeedNavigation from "../feed";
import { FIREBASE_AUTH } from "../../../firebaseConfig";
import ChatScreen from "../../screens/chat/list";
import { useChats } from "../../hooks/useChats";
import ColumnsScreen from "../../screens/columns";
import { t } from "../../i18n/strings";
import { RootState } from "../../redux/store";
import { Platform } from "react-native";

export type HomeStackParamList = {
  feed: undefined;
  Columns: undefined;
  Discover: undefined;
  Add: undefined;
  Inbox: undefined;
  Me: { initialUserId: string };
};

const Tab = createMaterialBottomTabNavigator<HomeStackParamList>();

export default function HomeScreen() {
  useChats();
  const currentUser = useSelector((state: RootState) => state.auth.currentUser);
  const isAndroid = Platform.OS === "android";
  // Keep the MI 8 layout exactly as verified. iOS already reserves its home
  // indicator outside this navigator, so only retain a small visual inset.
  const bottomInset = isAndroid ? 4 : 0;
  const tabBarHeight = isAndroid ? 60 + bottomInset : 58;

  return (
    <Tab.Navigator
      activeColor="#f2f5f4"
      inactiveColor="#9a9183"
      shifting={false}
      compact
      safeAreaInsets={{ bottom: 0 }}
      barStyle={{
        height: tabBarHeight,
        paddingBottom: bottomInset,
        marginBottom: 0,
        backgroundColor: "#06110e",
        borderTopWidth: 1,
        borderTopColor: "#285848",
      }}
      initialRouteName="feed"
    >
      <Tab.Screen
        name="feed"
        component={FeedNavigation}
        options={{
          tabBarLabel: t("tabFeed"),
          tabBarIcon: ({ color }) => (
            <Feather name="home" size={24} color={color} />
          ),
        }}
      />
      <Tab.Screen
        name="Columns"
        component={ColumnsScreen}
        options={{
          tabBarLabel: t("tabColumns"),
          tabBarIcon: ({ color }) => (
            <Feather name="grid" size={24} color={color} />
          ),
        }}
      />
      <Tab.Screen
        name="Discover"
        component={SearchScreen}
        options={{
          tabBarLabel: t("tabDiscover"),
          tabBarIcon: ({ color }) => (
            <Feather name="search" size={24} color={color} />
          ),
        }}
      />
      <Tab.Screen
        name="Add"
        component={CameraScreen}
        options={{
          tabBarLabel: t("tabAdd"),
          tabBarIcon: ({ color }) => (
            <Feather name="plus-square" size={24} color={color} />
          ),
        }}
      />
      <Tab.Screen
        name="Inbox"
        component={ChatScreen}
        options={{
          tabBarLabel: t("tabInbox"),
          tabBarIcon: ({ color }) => (
            <Feather name="message-square" size={24} color={color} />
          ),
        }}
      />
      <Tab.Screen
        name="Me"
        component={ProfileScreen}
        options={{
          tabBarLabel: t("tabMe"),
          tabBarIcon: ({ color }) => (
            <Feather name="user" size={24} color={color} />
          ),
        }}
        initialParams={{
          initialUserId:
            currentUser?.uid ?? FIREBASE_AUTH.currentUser?.uid ?? "",
        }}
      />
    </Tab.Navigator>
  );
}
